// removed by extract-text-webpack-plugin
module.exports = {"base":"Panel_base--1DfWp","isActive":"Panel_isActive--2qFL4","isDemo":"Panel_isDemo--2KpKQ","inner":"Panel_inner--6EUnF"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Panel/Panel.css
// module id = 1808
// module chunks = 16